// extracted by mini-css-extract-plugin
export default {"grid":"Articles_grid__EaOWI","editGrid":"Articles_editGrid__8DxKW","editModal":"Articles_editModal__2xb9Z","editModal__Buttons":"Articles_editModal__Buttons__AIt2r"};